import styled from 'styled-components';
import { Alert, TextButton } from '@shopline/dashboard-ui';
import Section from '../components/Section';
import { Well } from '../components/Well';

export const IntegrationFormSection = styled(Section)`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  > h3 {
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 16px;
    color: ${({ theme }) => theme.colors.INK_800};
  }
`;

export const IntegrationFormContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const IntegrationFormTitle = styled.h3`
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.colors.INK_800};
`;

export const IntegrationFormDescription = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin: 0;
  color: ${({ theme }) => theme.colors.INK_600};

  ul {
    margin: 4px 0 14px 0;
    padding-left: 17px;
  }
`;

export const GoogleMerchantIdContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const EnhancedWell = styled(Well)`
  display: flex;
  justify-content: space-between;
  margin: 0;

  > div {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const WellTitle = styled.h4`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.colors.INK_800};
`;

export const DisintegrateButton = styled(TextButton.Dark)`
  & {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.INK_500};
  }

  > svg {
    transform: scaleX(-1);
  }
`;

export const HiddenDisintegrateContainer = styled.div`
  > * {
    display: none;
  }
`;

export const DisconnectHint = styled.p`
  margin: 8px 0 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.INK_500};
`;

export const EnhancedSuccessAlert = styled(Alert.Success)`
  margin-bottom: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;

  ul {
    margin: 0;
    padding: 0;
    margin-left: 16px;
  }
`;
